"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debugging = void 0;
const path = require("path");
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const fs = require("fs");
/**
 * A simple wrapper around console logging that can disable / enable all debugging or logging messages.
 * Use EventStreamEvents for user facing debugging logs.
 */
class Debugging {
    static log(message, eventStream = null) {
        if (Debugging.debugOn) {
            if (Debugging.logToTerminal) {
                eventStream === null || eventStream === void 0 ? void 0 : eventStream.post(new EventStreamEvents_1.DotnetDebuggingMessage(message));
            }
            console.log(message);
            if (Debugging.logFile) {
                console.log(`Writing to ${Debugging.logFile}`);
                if (Debugging.logToTerminal) {
                    eventStream === null || eventStream === void 0 ? void 0 : eventStream.post(new EventStreamEvents_1.DotnetDebuggingMessage(`Writing to ${Debugging.logFile}`));
                }
                const file = fs.createWriteStream(Debugging.logFile, { flags: 'a+' });
                file.write(message);
            }
        }
    }
}
exports.Debugging = Debugging;
Debugging.logFile = path.join(__dirname, 'VsDotnetDebuggingLog.txt');
Debugging.debugOn = false;
Debugging.logToTerminal = true;
Debugging.logToFile = true;
;
//# sourceMappingURL=Debugging.js.map